module.exports = __webpack_public_path__ + "static/device_watch_android_light-7fbe50598a9bebe6e498d1d8421d9c1d.png";